'use client';

import { useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';
import { useCart } from 'frontastic';

type Props = {
  cartId: string;
};

const INTERVAL_MS = 2000;

const CheckoutPaymentCallback: React.FC<Props> = ({ cartId }) => {
  const router = useRouter();
  const { queryOrderByCartId } = useCart();
  const timeout = useRef<ReturnType<typeof setTimeout>>(null);

  useEffect(() => {
    const load = () => {
      queryOrderByCartId(cartId).then((res) => {
        if (!res?.orderId) {
          // retry, sometimes the payment takes time
          timeout.current = setTimeout(load, INTERVAL_MS);
        } else {
          timeout.current = null;
          router.replace(`/thank-you/?orderId=${res.orderId}`);
        }
      });
    };
    load();
    return () => {
      timeout.current && clearTimeout(timeout.current);
    };
  }, [queryOrderByCartId, cartId, router]);

  return (
    <div className="flex h-[80vh] items-center justify-center">
      <div className="loading-full-screen" />
    </div>
  );
};

export default CheckoutPaymentCallback;
